import React, { createContext } from 'react'
import { useKeycloak } from '@react-keycloak/web'
import UserServices from './Services/Consumers/UserServices'
import { toast } from 'react-toastify'
import Notification from './components/Dashboard/Notification/Notification'
import { filterData } from './utils/helpers'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import Cookies from 'js-cookie'
import SubscriptionServices from './Services/Consumers/SubscriptionServices'

const AuthenticatedUserContext = createContext({})

const AuthenticatedUserProvider = ({ children, locale }) => {
  const { keycloak, initialized } = useKeycloak()
  const intl = useIntl()
  let location = useLocation()
  const [adminSectionType, setAdminSectionType] = React.useState('')
  const [userDataLoading, setUserDataLoading] = React.useState(false)
  const [userDataFailure, setUserDataFailure] = React.useState(false)
  const [userData, setUserData] = React.useState({})
  const [bootData, setBootData] = React.useState({})
  const [isAdmin, setIsAdmin] = React.useState(false)


  const [roles, setRoles] = React.useState({})
  const [countries, setCountries] = React.useState([])
  const [governmentsLoader, setGovernmentsLoader] = React.useState(false)
  const [governments, setGovernments] = React.useState([])
  const [citiesLoader, setCitiesLoader] = React.useState(false)
  const [cities, setCities] = React.useState([])

  const [addAdminSuccess, setAddAdminSuccess] = React.useState(false)

  const getUserData = React.useCallback(() => {
    if (!!keycloak?.authenticated) {
      setUserDataFailure(false)
      setUserDataLoading(true)
      UserServices.getProfileData({ headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` } }).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          if ((!!result.response && result.response.status === 423)) {
            let user = keycloak?.loadUserInfo()
            user.then((result) => {
              if (!!result) {
                setUserData(result)
              }
            })
          } else {
            setUserDataFailure(true)
          }
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            setIsAdmin(result.data.data.is_admin)
            setUserData(result.data.data)
          } else {
            setUserDataFailure(true)
          }
        }
      }).then(() => {
        setUserDataLoading(false)
      })
    }
  }, [keycloak])

  const getRoles = () => {
    if (!!keycloak?.authenticated) {
      ('subscription' === adminSectionType ? SubscriptionServices : UserServices).getRoles({
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
        params: { 'page': 0, 'limit': 0 }
      }).then((result) => {
        if (!!result && !!result.data && !!result.data.data) {
          let newRoles = result.data.data
          newRoles.forEach((role) => {
            delete role.permissions
          })
          setRoles(newRoles)
          // let rolesIds = (!!result.data.data && !!result.data.data.length) ?
          //   result.data.data.map(role => role.id) : []
          // setRoles({ 'roles': result.data.data, 'rolesIds': rolesIds })
        }
      })
    }
  }

  const getCountries = () => {
    if (!!keycloak?.authenticated && !countries.length) {
      UserServices.getCountries({
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
        params: { 'page': 0, 'limit': 0 }
      }).then((result) => {
        if (!!result && !!result.data && !!result.data.data) {
          setCountries(result.data.data)
        }
      })
    }
  }
  const getGovernments = (country) => {
    if (!!keycloak?.authenticated && !!country) {
      setGovernmentsLoader(true)
      UserServices.getGovernments(country, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
        params: { 'page': 0, 'limit': 0 }
      }).then((result) => {
        if (!!result && !!result.data && !!result.data.data) {
          setGovernments(result.data.data)
        }
      }).then(() => {
        setGovernmentsLoader(false)
      })
    }
  }
  const getCities = (government) => {
    if (!!keycloak?.authenticated && !!government) {
      setCitiesLoader(true)
      UserServices.getCities(government, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
        params: { 'page': 0, 'limit': 0 }
      }).then((result) => {
        if (!!result && !!result.data && !!result.data.data) {
          setCities(result.data.data)
        }
      }).then(() => {
        setCitiesLoader(false)
      })
    }
  }

  const checkAdminSection = React.useCallback(() => {
    switch (window.location.pathname.split('/')[1]) {
      case 'workspace':
        setAdminSectionType('workspace')
        Cookies.set('admin_section_type', 'workspace')
        break
      case 'subscription':
        setAdminSectionType('subscription')
        Cookies.set('admin_section_type', 'subscription')
        break
      default:
        break
    }
  }, [])

  React.useEffect(() => {
    // eslint-disable-next-line
    if (!!initialized) {
      getUserData()
      checkAdminSection()
    }
  }, [initialized, getUserData, checkAdminSection])

  React.useEffect(() => {
    if (!!location) {
      checkAdminSection()
    }
  }, [checkAdminSection, location, locale])

  const getSubscriptionBootData = () => {
    if (!!keycloak?.authenticated) {
      SubscriptionServices.getBootData({ headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` } }).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          let message = intl.formatMessage({ id: 'SubscriptionBoot.FormErrorAlert' })

          if (result.response.data && result.response.data.status) {
            if (result.response.data.status.errors && result.response.status === 422) {
              message = result.response.data.status.errors
            } else if (result.response.data.status.message) {
              message = result.response.data.status.message
            }
          }
          handleNotificationCall({
            type: 'defence',
            message: message,
            color: 'error'
          }, 'error')
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            setBootData(result.data.data)
          }
        }
      })
    }
  }

  React.useEffect(() => {
      if (adminSectionType === 'subscription' && !!keycloak?.authenticated) {
        getSubscriptionBootData()
      }
    },// eslint-disable-next-line react-hooks/exhaustive-deps
    [adminSectionType, keycloak?.authenticated])


  const handleAdminSectionChange = (sectionType) => {
    setAdminSectionType(sectionType)
    Cookies.set('admin_section_type', sectionType)
  }

  const handleNotificationCall = (notificationProps, toastType) => {
    return toast(
      <Notification
        {...notificationProps}
        variant='contained'
        className={'notification-component'}
      />,
      {
        type: toastType,
        position: toast.POSITION.BOTTOM_LEFT,
        progressClassName: 'notification-progress-wrapper',
        className: 'notification-wrapper'
      }
    )
  }

  const resetAddAdminStatus = () => {
    setAddAdminSuccess(false)
  }
  const addAdminSubmit = (values, FormikActions) => {
    if (!!keycloak?.authenticated) {
      FormikActions.setSubmitting(true);
      ('subscription' === adminSectionType ? SubscriptionServices : UserServices).addNewAdmin(filterData(values), { headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` } },
        FormikActions.setSubmitting, null, FormikActions).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })

          if (result.response.data && result.response.data.status) {
            if (result.response.data.status.errors && result.response.status === 422) {
              message = result.response.data.status.errors
            } else if (result.response.data.status.message) {
              message = result.response.data.status.message
            }
          }
          handleNotificationCall({
            type: 'defence',
            message: message,
            color: 'error'
          }, 'error')
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({ id: 'AddAdmin.FormSuccessAlert' }),
              color: 'success'
            }, 'success')
            setTimeout(() => setAddAdminSuccess(true), 300)
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
          }
        }
      }).then(() => {
        FormikActions.setSubmitting(false)
      })

    }
  }

  const [settingsLoading, setSettingsLoading] = React.useState(false)
  const [settings, setSettings] = React.useState([])
  const getSettings = () => {
    if (!!keycloak?.authenticated) {
      setSettingsLoading(true);
      ('subscription' === adminSectionType ? SubscriptionServices : UserServices).getSettings({
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
        params: { 'page': 0, 'limit': 0 }
      }).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
          if (result.response.data && result.response.data.status) {
            if (result.response.status === 403) {
              message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
            } else if (result.response.data.status.errors && result.response.status === 422) {
              message = result.response.data.status.errors
            } else if (result.response.data.status.message) {
              message = result.response.data.status.message
            }
          }
          handleNotificationCall({
            type: 'defence',
            message: message,
            color: 'error'
          }, 'error')
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            setSettings(result.data.data)
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
          }
        }
      }).then(() => {
        setSettingsLoading(false)
      })
    }
  }

  const settingValueSubmit = (sId, values, FormikActions, setValue) => {
    if (!!keycloak?.authenticated) {
      FormikActions.setSubmitting(true);
      ('subscription' === adminSectionType ? SubscriptionServices : UserServices).updateSetting(sId, { 'value': (sId === 10 && adminSectionType === 'workspace') ? values.value : values.value.toString() }, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
      }, FormikActions.setSubmitting).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          handleNotificationCall({
            type: 'defence',
            message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
            color: 'error'
          }, 'error')
        } else {
          if (!!result && !!result.data && !!result.data.data) {

            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({ id: 'Settings.List.Update.Success' }),
              color: 'success'
            }, 'success')
            setValue(values.value)

          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
          }
        }
      }).then(() => {
        FormikActions.setSubmitting(false)
      })

    }
  }

  const [importUPTCPFileResults, setImportUPTCPFileResults] = React.useState(null)
  const resetImportUPTCPFileResults = () => {
    setImportUPTCPFileResults(null)
  }
  const importUPTCPFile = (values, FormikActions) => {
    if (!!keycloak?.authenticated) {
      FormikActions.setSubmitting(true)
      setImportUPTCPFileResults(null)
      const data = new FormData()
      if (!!values.file) {
        data.append('file', values.file)
      }
      UserServices.importUPTCPFile(data, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
      }, FormikActions.setSubmitting).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          handleNotificationCall({
            type: 'defence',
            message: intl.formatMessage({ id: 'UPTCPForm.Error' }),
            color: 'error'
          }, 'error')
        } else {
          if (!!result && !!result.data && !!result.data.data) {

            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({ id: 'UPTCPForm.Success' }),
              color: 'success'
            }, 'success')
            setImportUPTCPFileResults(result.data.data)

          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'UPTCPForm.Error' }),
              color: 'error'
            }, 'error')
          }
        }
      }).then(() => {
        FormikActions.setSubmitting(false)
      })

    }
  }

  return (
    <AuthenticatedUserContext.Provider value={{
      adminSectionType: adminSectionType,
      handleAdminSectionChange,

      userDataLoading: userDataLoading,
      userDataFailure: userDataFailure,
      userData: userData,
      bootData: bootData,
      isAdmin: isAdmin,
      roles: roles,
      getRoles,
      countries: countries,
      getCountries,
      governmentsLoader: governmentsLoader,
      governments: governments,
      getGovernments,
      citiesLoader: citiesLoader,
      cities: cities,
      getCities,

      handleNotificationCall,
      addAdminSuccess: addAdminSuccess,
      addAdminSubmit,
      resetAddAdminStatus,

      settingsLoading: settingsLoading,
      settings: settings,
      getSettings,
      settingValueSubmit,

      importUPTCPFile,
      resetImportUPTCPFileResults,
      importUPTCPFileResults: importUPTCPFileResults

    }}>
      {children}
    </AuthenticatedUserContext.Provider>
  )
}
const AuthenticatedUserConsumer = AuthenticatedUserContext.Consumer

export { AuthenticatedUserProvider, AuthenticatedUserConsumer }
